var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVerySadGrey(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#D8D8D8",
    fillRule: "nonzero",
    d: "M24 48C10.745 48 0 37.255 0 24S10.745 0 24 0s24 10.745 24 24-10.745 24-24 24z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BDBDBD",
    fillRule: "nonzero",
    d: "M15 23a3 3 0 1 1 0-6 3 3 0 0 1 0 6zM33 23a3 3 0 1 1 0-6 3 3 0 0 1 0 6zM23.76 29.13c6.76 0 15.642 7.14 12.24 8.083-3.402.943-20.955.943-24.48 0-3.525-.944 5.48-8.083 12.24-8.083z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M13.493 7.338l-.097.403a1 1 0 0 1-.522.659c-1.335.674-2.533 1.67-3.593 2.988C8.113 12.84 6.924 15.2 5.71 18.47c.082-2.847.697-5.218 1.846-7.113 1.041-1.716 2.82-3.214 5.335-4.494a.421.421 0 0 1 .6.474z",
    opacity: 0.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerySadGrey);
export default __webpack_public_path__ + "static/media/very-sad-grey.5318b785fa076df1fadeff8f81b9b976.svg";
export { ForwardRef as ReactComponent };